<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
      <template v-slot:top>
        <TableTopMid
          :loading="loading"
          @addItem="mappingMID"
          @getData="getData"
        />
      </template>

      <template v-slot:body-prepend>
        <TableFilterMid :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="mappingMID(item, 'view')">
              mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="mappingMID(item, 'edit')">
              mdi-pencil
            </v-icon>
          </td>
      </template>
    </TableView>
  </v-card>
</template>

<script>

import mappingMidMixin from '../../components/user-management/mapping-mid/mappingMidMixin';
import { TableFilterMid, TableTopMid } from '../../components/user-management/mapping-mid/components';

export default {
  mixins: [mappingMidMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableFilterMid,
    TableTopMid
  }
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>

<style scoped>
.td1 {
  width: 35%;
  text-align: left;
  vertical-align: top;
}
.td2 {
  width: 15%;
  text-align: center;
  vertical-align: top;
}
.td3 {
  width: 50%;
  text-align: left;
  vertical-align: top;
}
</style>
